import HttpClient from '@microbadevs/http-client'
import authService from './authService'

export default class HttpClientService {
  static getReportAPIHttpClient() {
    
    return new HttpClient(localStorage.getItem("report_path"), process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken())
  }
  static getAPIHttpClient () {
    return new HttpClient(localStorage.getItem("api_path"), process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken())
  }
  static getPdfHttpClient () {
    return new HttpClient(localStorage.getItem("report_path"), process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken(), true)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/services/httpClientService.js
// module id = ZtIF
// module chunks = 0